function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import GoogleMapsContext from "./GoogleMapsContext.js";
var withGoogleMaps = function withGoogleMaps(Wrapped) {
  var WithGoogleMaps = function WithGoogleMaps(props) {
    return /*#__PURE__*/React.createElement(GoogleMapsContext.Consumer, null, function (_ref) {
      var google = _ref.google,
        instance = _ref.instance;
      return /*#__PURE__*/React.createElement(Wrapped
      // @TODO: remove the cast once TypeScript fixes the issue
      // https://github.com/Microsoft/TypeScript/issues/28938
      , _extends({}, props, {
        google: google,
        googleMapsInstance: instance
      }));
    });
  };
  return WithGoogleMaps;
};
export default withGoogleMaps;